import moment from 'moment';
import merge from 'lodash/merge';
import isPlainObject from 'lodash/isPlainObject';

const keySuffix = 'credit24.store';
const keySuffixOld = 'credit24.data'; // remove it later

const cacheQueryStringTtl = { minutes: 10 };

export const LC_NAMESPACE = `${COUNTRY}.${keySuffix}`;

export const LC_NAMESPACE_OLD = `${COUNTRY}.${keySuffixOld}`; // remove it later

const LC_NAMESPACE_PRINCIPAL = `${LC_NAMESPACE}.principal`;
const LC_NAMESPACE_QUERY_STRING = `${LC_NAMESPACE}.querySring`;
const LC_NAMESPACE_PERSISTANT = `${LC_NAMESPACE}.persistant`;

export function testLocalStorageSupport() {
  const testKey = 'test';
  try {
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

const isLocalStorageSupported = testLocalStorageSupport();

export function removeLocalStorageItem(key) {
  if (isLocalStorageSupported) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log(e);
    }
  }
}

export function getLocalStorageItem(key) {
  if (isLocalStorageSupported) {
    return JSON.parse(localStorage.getItem(key));
  }
  return false;
}

export function saveLocalStorageItem(key, value) {
  if (isLocalStorageSupported) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.log(e);
    }
  }
}

export function getSavedAppState(id) {
  removeLocalStorageItem(LC_NAMESPACE_OLD);
  let state;
  if (isLocalStorageSupported) {
    state = getLocalStorageItem(LC_NAMESPACE);
  }
  if (!isPlainObject(state)) {
    removeLocalStorageItem(LC_NAMESPACE);
    return false;
  }
  // return saved data for specified id;
  if (id) {
    if (state && state[id] && state[id].timestamp) {
      const timestamp = state[id].timestamp;
      const expireTime = moment(timestamp).add(3, 'd').format();
      if (moment(timestamp).isValid() && !moment().isAfter(expireTime)) {
        return state[id];
      }
    }
    delete state[id];
    saveLocalStorageItem(LC_NAMESPACE, state);
    return false;
  }
  // return all saved data
  return state;
}

export function saveAppState(id, content) {
  const currentState = getSavedAppState();
  let finalState = {};
  if (currentState) {
    finalState = merge({}, currentState);
  }
  finalState[id] = merge({}, finalState[id], content);
  if (finalState[id].loan) {
    if (finalState[id].loan.id) {
      delete finalState[id].loan.id;
    }
    if (finalState[id].loan.mmps) {
      // mmps is quite big for localstorage, so we are not saving it
      finalState[id].loan.mmps = null;
    }
    if (finalState[id].loan.mmpsByGroup) {
      // mmpsGroup is quite big for localstorage, so we are not saving it
      finalState[id].loan.mmpsByGroup = null;
    }
    if (finalState[id].loan.mmpsByMonth) {
      // mmpsByMonth is quite big for localstorage, so we are not saving it
      finalState[id].loan.mmpsByMonth = null;
    }
    if (finalState[id].loan.productsByPrincipals) {
      // productsByPrincipals is quite big for localstorage, so we are not saving it
      finalState[id].loan.productsByPrincipals = null;
    }
  }
  saveLocalStorageItem(LC_NAMESPACE, finalState);
}

export function savePrincipalValue(value) {
  const data = {
    value,
    timestamp: moment().format(),
  };
  saveLocalStorageItem(LC_NAMESPACE_PRINCIPAL, data);
}

export function getPrincipalValue() {
  let data;
  if (isLocalStorageSupported) {
    data = getLocalStorageItem(LC_NAMESPACE_PRINCIPAL);
  }
  if (!isPlainObject(data)) {
    removeLocalStorageItem(LC_NAMESPACE_PRINCIPAL);
    return false;
  }
  if (data && data.timestamp) {
    const timestamp = data.timestamp;
    const expireTime = moment(timestamp).add(3, 'd').format();
    if (moment(timestamp).isValid() && !moment().isAfter(expireTime)) {
      return data.value;
    }
  }
  return false;
}

export function removeCachedQueryString() {
  removeLocalStorageItem(LC_NAMESPACE_QUERY_STRING);
}

export function getCachedQueryString(removeFromLocalStorage) {
  let data;
  if (isLocalStorageSupported) {
    data = getLocalStorageItem(LC_NAMESPACE_QUERY_STRING);
  }
  if (removeFromLocalStorage) {
    removeCachedQueryString();
  }
  if (!isPlainObject(data)) {
    removeCachedQueryString();
    return false;
  }
  if (data && data.timestamp) {
    const time = data.ttl || cacheQueryStringTtl;
    if (moment(data.timestamp).add(time).isAfter()) {
      return data.value;
    }
    removeCachedQueryString();
    return false;
  }
  return false;
}

export function cacheQueryString(value, ttl = cacheQueryStringTtl) {
  const data = {
    value,
    timestamp: moment().format(),
    ttl,
  };
  saveLocalStorageItem(LC_NAMESPACE_QUERY_STRING, data);
}

export function removeSignUpGateData() {
  if (isLocalStorageSupported) {
    sessionStorage.removeItem('signupgate');
  }
}

export function saveSignUpGate(data) {
  if (isLocalStorageSupported) {
    removeSignUpGateData();
    try {
      sessionStorage.setItem('signupgate', JSON.stringify(data));
    } catch (e) {
      console.log(e);
    }
  }
}

export function getSignUpGateData() {
  let data;
  if (isLocalStorageSupported) {
    data = JSON.parse(sessionStorage.getItem('signupgate'));
  }
  return data;
}

export function getPersistentItem(key) {
  const data = getLocalStorageItem(LC_NAMESPACE_PERSISTANT);
  if (data && data[key]) {
    return data[key];
  }
  return {};
}

export function savePersistentItem(key, value) {
  const data = {
    ...getLocalStorageItem(LC_NAMESPACE_PERSISTANT),
    [key]: value,
  };
  saveLocalStorageItem(LC_NAMESPACE_PERSISTANT, data);
}

export function removePersistentItem(key) {
  const data = getLocalStorageItem(LC_NAMESPACE_PERSISTANT);
  if (data) {
    delete data[key];
    saveLocalStorageItem(LC_NAMESPACE_PERSISTANT, data);
  }
}
